import styled from 'styled-components';
import { MdEdit, MdDelete } from 'react-icons/md';

export const Container = styled.div`
  padding: 5px 0;
  width: 100%;
`;

export const WrapperTable = styled.div`
  margin-top: 20px;
`;

export const WrapperPopover = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

export const PopoverText = styled.p`
  font-size: 14px;
  color: #122d58;
  margin: 0;
`;

export const PopoverButton = styled.button`
  padding: 8px 16px;
  background-color: #122d58;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;

  &:hover {
    background-color: #0f2347;
  }
`;

export const EditIcon = styled(MdEdit).attrs({ size: '19px' })`
  color: #4caf50;
  cursor: pointer;
  margin-right: 26px;
  &:hover {
    color: #388e3c;
  }
`;

export const DeleteIcon = styled(MdDelete).attrs({ size: '19px' })`
  color: #f44336;
  cursor: pointer;
  margin-right: 26px;
  &:hover {
    color: #d32f2f;
  }
`;

